import React, { ReactNode } from 'react'
import { Field } from 'redux-form'
import { Translate } from 'react-localize-redux'
import { Input, Spin } from 'antd'
import moment from 'moment'
import { getterHash } from 'core/utils/helpers'
import history from 'core/history/history'
import FormStepper from 'shared/components/form-stepper'
import ApiTokenFormWrapper from './ApiTokenForm.form'
import InputFieldFetchApiTokens from '../InputFieldFetchApiTokens'
import DatePickerField from 'shared/components/fields/date-picker/DatePickerField'
import { disabledDateFromTo } from 'shared/helpers/DateTimeHelper'
import { ApiTokenFormProps, ApiTokenFormValues } from './ApiTokenForm.types'
import { ApiTokenFormAdapter, ApiTokenFormFields } from './ApiTokenForm.constants'
import styles from '../ApiTokens.module.scss'
import { FormMode } from 'shared/interfaces'
import { ymdFormat } from 'core/utils/constants'

export default class ApiTokenForm extends FormStepper<ApiTokenFormProps> {
  state = {
    step: getterHash(this.props.location),
    lastPage: 1,
    showConfirmModal: false
  }

  protected getTitleForm () {
    let textLabel = ''
    switch (this.state.step) {
      case 1:
        textLabel = this.props.mode === 'create' ? 'apiTokens.form.createToken' : 'apiTokens.form.editToken'
        break
      case 2:
        textLabel = this.props.apiToken ? 'apiTokens.congratulations' : ''
        break
      default:
        return ''
    }
    return <Translate id={textLabel} />
  }

  private finish = (): void => {
    if(document.referrer === '') {
      window.close()
    }
    history.go(-2)
    this.props.destroyForm(ApiTokenFormAdapter.name)
  }

  private onCancel = (): void => {
    if(this.props.onCancel) {
      this.props.onCancel()
    }
    this.props.destroyForm(ApiTokenFormAdapter.name)
  }

  private onSubmit = (values: ApiTokenFormValues): void => {
    if (this.props.mode === FormMode.create) {
      const location = this.props.location
      history.replace(location.pathname, '')
      location.hash = '2'
      history.push({
        pathname: location.pathname,
        hash: location.hash
      })
      this.setState({
        step: parseInt(location.hash)
      })
    }
    this.props.onSubmit(values)
  }

  private getInitialValues = (): Partial<ApiTokenFormValues> => {
    const { mode, apiTokenValue, userId } = this.props
    if (apiTokenValue && mode === FormMode.edit) {
      return {
        name: apiTokenValue.name,
        end_date: apiTokenValue.end_date ? moment(apiTokenValue.end_date).format(ymdFormat) : null,
        apiTokenValue: apiTokenValue,
        userId: userId
      }
    }
    return {
      userId: userId
    }
  }

  protected getCurrentForm (): ReactNode {
    const isTokenCreated = !!this.props.apiToken && !this.props.isLoading
    switch (this.state.step) {
      case 1:
        return (
          <ApiTokenFormWrapper
            onSubmit={this.onSubmit}
            onCancel={this.onCancel}
            step={this.state.step}
            lastPage={this.state.lastPage}
            isLoading={this.props.isLoading}
            initialValues={this.getInitialValues()}
            mode={this.props.mode}
            submitBtnLabel={this.props.mode === FormMode.create ? 'common.form.buttons.createBtn' : 'common.form.buttons.updateBtn'}
          >
            <>
              <Field
                name={ApiTokenFormFields.name}
                component={InputFieldFetchApiTokens}
                type='text'
                label='common.form.name'
                placeholder='common.form.name'
                required
                maxLength={200}
              />
              <Field
                disabledDateValidators={[disabledDateFromTo(moment().utc().format('YYYY-MM-DD'))]}
                name={ApiTokenFormFields.endDate}
                dateFormat={this.props.dateFormat}
                component={DatePickerField}
                label='serviceUser.endDate'
                placeholder='common.form.endDate'
              />
            </>
          </ApiTokenFormWrapper>
        )
      case 2:
        return (
          <ApiTokenFormWrapper
            onSubmit={this.finish}
            skipCancel={true}
            step={this.state.step - 1}
            lastPage={this.state.lastPage}
            isLoading={this.props.isLoading}
            initialValues={this.getInitialValues()}
            mode={this.props.mode}
            submitBtnLabel={isTokenCreated ? 'common.form.buttons.finishBtn' : undefined}
          >
            {!isTokenCreated
              ? (
                <div className='spin-wrap'><Spin /></div>
              )
              : (
                <div>
                  <p className={styles.warningText}><Translate id='apiTokens.showOnce' /></p>
                  <p className={styles.warningText}><Translate id='apiTokens.saveToken' /></p>
                  <Input.TextArea
                    rows={3}
                    value={this.props.apiToken}
                    className={styles.textArea}
                  />
                </div>
              )}
          </ApiTokenFormWrapper>
        )
    }
  }
}
